var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNumberedList = function SvgNumberedList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M11 4h9m-8.85 5H20M5.25 9V4L4 5.25M11 14h9m-8.85 5H20M4 15a1 1 0 0 1 1-1h.614a1.229 1.229 0 0 1 .933 2.028L4 19h3M4 9h2.5",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgNumberedList;